import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    Button,
} from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(2),
    },
    input: {
        display: 'none',
    },
    submitButton: {
        marginTop: theme.spacing(3),
    },
}));

export default function FormDocumentos(props) {
    const classes = useStyles();

    return (
        <>
            <div className={classes.paper}>
                <form className={classes.form} autoComplete="off">
                    <Grid item xs={12}>
                        <input
                            className={classes.input}
                            id="contained-button-file"
                            multiple
                            type="file"
                        />
                        <label htmlFor="contained-button-file">
                            <Button
                                variant="contained"
                                color="default"
                                fullWidth
                                component="span"
                                startIcon={<CloudUploadIcon />}
                            >
                                Incluir Currículo
                             </Button>
                        </label>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            component="span"
                            className={classes.submitButton}
                        >
                            Salvar
                         </Button>
                    </Grid>
                </form>
            </div>
        </>
    );
}